import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import { flex } from "shared/theme/mixins";

export const StyledNoOptionContainer = styled(Box)`
  ${flex({ ai: "center", jc: "space-between" })}
  height: 40px;
  padding: 0;
  cursor: pointer;
`;
